import { render } from "./clientsSection.vue?vue&type=template&id=0f66da8d&scoped=true"
import script from "./clientsSection.vue?vue&type=script&lang=js"
export * from "./clientsSection.vue?vue&type=script&lang=js"

import "./clientsSection.vue?vue&type=style&index=0&id=0f66da8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f66da8d"]])

export default __exports__